import {action, makeObservable, observable} from "mobx";
import {IVillageService} from "../../../services/villageService";
import VillageItem from "./models/villageItem";

export interface IVillagesDomainStore {
  villageList: VillageItem[];
  getAllVillages: () => Promise<void>;
}

export class VillagesDomainStore implements IVillagesDomainStore {
  private villageService: IVillageService;
  villageList: VillageItem[] = [];

  constructor(villageService: IVillageService) {
    makeObservable(this, {villageList: observable, getAllVillages: action});
    this.villageService = villageService;
  }

  getAllVillages = async () => {
    let data = await this.villageService.getVillageData();
    this.villageList = data.map((d: any) => new VillageItem(d.id, d.name));
  };
}
